import { Link } from "react-router-dom";
import { ArrowRight, Clock, MessageSquare } from "lucide-react";
import { BLOGS } from "../data/blogs";
import { SiteHeader, SiteFooter, WA } from "../components/SiteChrome";
import { Seo, faqSchema, breadcrumbSchema } from "../components/Seo";

export default function BlogIndex() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-[#2D2A26] bg-[#FAF6EF]">
      <Seo
        title="Pet Pathology Guides & Resources | Animal Analytics, Kolkata"
        description="Expert guides on dog blood tests, pet diagnostic tests, costs and choosing the best animal pathology lab in Kolkata & West Bengal. Trusted advice from Animal Analytics."
        canonical="/blog"
        jsonLd={[
          breadcrumbSchema([
            { name: "Home", url: "/" },
            { name: "Guides", url: "/blog" },
          ]),
        ]}
      />
      <SiteHeader />

      <section className="py-16 sm:py-24 bg-[#1A4D45] text-[#FAF6EF]">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 space-y-5">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C89D3C]">Guides &amp; Resources</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold leading-tight">
            Pet Pathology Guides for Kolkata Pet Owners
          </h1>
          <p className="text-base sm:text-lg text-[#FAF6EF]/85 font-light max-w-2xl">
            Clear, trustworthy guides on dog blood tests, pet diagnostic tests, costs and how to choose the best animal pathology lab in Kolkata &amp; West Bengal.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20 flex-1">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          {BLOGS.map((b) => (
            <Link
              key={b.slug}
              to={`/blog/${b.slug}`}
              data-testid={`blog-card-${b.slug}`}
              className="group bg-[#FDFBF7] border border-[#E8E2D2] rounded-2xl p-7 flex flex-col justify-between shadow-sm hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="space-y-4">
                <span className="inline-block text-[11px] uppercase tracking-wider font-semibold text-[#C89D3C]">{b.category}</span>
                <h2 className="font-serif text-xl font-bold text-[#1A4D45] leading-snug group-hover:text-[#C89D3C] transition-colors">
                  {b.h1}
                </h2>
                <p className="text-sm text-[#4A4743] font-light leading-relaxed">{b.heroSubtitle}</p>
              </div>
              <div className="pt-6 flex items-center justify-between text-xs text-[#4A4743]/80">
                <span className="inline-flex items-center gap-1"><Clock size={13} /> {b.readTime}</span>
                <span className="inline-flex items-center gap-1 font-semibold text-[#1A4D45]">Read <ArrowRight size={14} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-6 text-center space-y-5">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#1A4D45]">Need a test for your pet?</h2>
          <p className="text-[#4A4743] font-light">Home sample collection across Kolkata. We come to you and send the report on WhatsApp.</p>
          <a href={WA} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#C89D3C] text-white hover:bg-[#b08732] font-semibold uppercase tracking-wider text-sm transition">
            <MessageSquare size={16} /> WhatsApp Us
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
